import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  constructor() { }

  loader0show(){
    $('#bems-loader-wrapper').show();
  }

  loader0hide() {
    setTimeout(()=>{  $('#bems-loader-wrapper').hide(); }, 0);
  }


}
